<template>
  <div style="width: 100%; height: 100%" v-resize:debounce="recalcWidthHeight">
    <v-row class="ma-0 pa-0" :class="isOnMobile ? 'box-container' : 'box-container-horizontal'">
      <div class="row-header ma-0 pa-0" :class="isOnMobile ? ' px-2' : 'pl-2'">
        <div class="ma-0 pa-0" :style="'max-width: ' + virtualScrollerWidth + 'px; height: ' + filtersHeight + 'px'">
          <v-select class="ma-0 pa-0 py-1" outlined v-model="devsSortType" :items="devsSortTypes" item-text="name" dense label="Подреди по"></v-select>
        </div>
        <v-virtual-scroll :height="virtualScrollerHeight" :item-height="buttonsHeight" :items="getItems" :width="virtualScrollerWidth">
          <template v-slot="{ item }">
            <v-card class="ma-0 pa-0" width="100%" :height="buttonsHeight" outlined @click="select(item)" :style="currentItem == item ? 'background-color: ' + Colors.ActiveItemBackground : ''">
              <v-row class="ma-0 pa-0" justify="start" align="center" :style="'height: ' + buttonsHeight + 'px'">
                <v-btn class="ma-0 pa-0" text style="pointer-events: none; width: 100%">
                  <v-icon class="mx-2" small v-if="item.Status" :color="item.Status.Color">{{ item.Status.Icon }}</v-icon>
                  <span class="flex-grow-1 text-left">{{ item.Name.length > 15 ? item.Name.substring(0, 15) + "..." : item.Name }}</span>
                </v-btn>
              </v-row>
            </v-card>
          </template>
        </v-virtual-scroll>
      </div>
      <div class="ma-0 pa-0 row-content">
        <div class="box-container mx-1">
          <div class="row-header">
            <v-expansion-panels v-if="currentItem" class="ma-0 pa-0" multiple :value="expanded">
              <v-expansion-panel class="ma-0 pa-0">
                <v-divider class="ma-0 pa-0"></v-divider>
                <v-expansion-panel-header class="ma-0 pa-0 px-3 pr-8" align="center" justify="center">
                  <span>{{ currentItem.Name + " (" + currentItem.sn + ")" + (currentTelemetryView ? ", " + currentTelemetryView.VendingMachine.ModelNumber.trim() : "") }}</span>
                  <span v-if="currentTelemetryView" class="text-right pr-4">{{ "(" + currentTelemetryView.Version + ")\n" }}</span>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="ma-0 pa-0" style="white-space: pre-wrap;">
                  <span>{{ "Адрес: " + currentItem.Address + "\n" }}</span>
                  <span v-if="currentItem.PSName">{{ "Търговски обект: " + currentItem.PSName + "\n" }}</span>
                  <span v-if="currentItem.Technician">{{ "Поддръжка: " + currentItem.Technician.n + ", тел: " + currentItem.Technician.p + "\n" }}</span>
                  <template v-if="currentTelemetryView">
                    <!-- <span v-if="currentTelemetryView.Date.getTime() == currentTelemetryView.DatePeriodStart.getTime()">{{ "Последно зареждане: " + currentTelemetryView.DatePeriodStart.toTremolFpString() + "\n" }}</span> -->
                    <!-- <span>{{ "Автоматичен одит на: " + currentTelemetryView.Date.toTremolFpString() }}</span> -->
                    <!-- <span>{{ "Модел: " + currentTelemetryView.VendingMachine.ModelNumber.trim() + "  (" + currentTelemetryView.Version + ")\n" }}</span> -->
                    <span>{{ "Зареждане: " + currentTelemetryView.DatePeriodStart.toTremolFpString() + "\n" }}</span>
                    <span style="white-space: pre;">{{ "Автоматичен одит:     " + currentTelemetryView.Date.toTremolFpString() + "\n" }}</span>
                  </template>
                  <template v-else>
                    <v-avatar size="25" class="mr-3">
                      <v-icon color="red">mdi-alert</v-icon>
                    </v-avatar>
                    <span>{{ "Липсват данни за зареждане на машината!" }}</span>
                  </template>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
          <div class="row-content">
            <TelemetryView :diff="true" v-if="currentItem && currentTelemetryView" :device="currentItem" :telemetryData="currentTelemetryView" />
          </div>
        </div>
      </div>
    </v-row>
  </div>
</template>

<script>
import DataManager, { ErrorMessage } from "../../js/DataManager";
import TelemetryView from "./TelemetryView";

export default {
  components: {
    TelemetryView,
  },
  data() {
    return {
      expanded: [0],
      dataitems: [],
      datatype: null,
      currentItem: null,
      currentTelemetryView: null,
      buttonsHeight: 33,
      filtersHeight: 46,
      virtualScrollerHeight: 500,
      virtualScrollerWidth: 250,
      intervalRecalcSize: null,
      mapHeight: "100%",
      mapWidth: "100%",
      devsFilterTypes: [
        { id: 0, name: "Всички ФУВАС" },
        // { id: 1, name: "Блокирали ФУВАС" },
      ],
      devsFilterType: "Всички ФУВАС",
      devsSortTypes: [
        { id: 0, name: "Име на ФУВАС", prop: "Name" },
        { id: 1, name: "Сериен номер", prop: "sn" },
        { id: 2, name: "Адрес", prop: "Address" },
      ],
      devsSortType: "Име на ФУВАС",
      devsSearch: null,
    };
  },
  methods: {
    setTitleAndData(meta, error) {
      this.datatype = meta.datatype;
      this.title = meta.title;
      if (error.ErrorCode == ErrorMessage.ERROR_CODE_OK) {
        this.refreshData();
      } else {
        this.message = error.Message;
      }
    },
    async refreshData() {
      this.dataitems = DataManager.getData(this.datatype, true).filter(i => i.IsFuvas && !i.IsOldFuvas);
    },
    select(item) {
      if (item.LastTelemetryCalculated) {
        this.currentTelemetryView = item.LastTelemetryCalculated;
      } else {
        this.currentTelemetryView = null;
      }
      this.currentItem = item;
    },
    async recalcWidthHeight() {
      new Promise(resolve => {
        if (this.intervalRecalcSize) clearTimeout(this.intervalRecalcSize);
        this.intervalRecalcSize = setTimeout(() => {
          if (this.isOnMobile) {
            this.virtualScrollerHeight = window.innerHeight / 2 - this.$vuetify.application.top - this.$vuetify.application.footer - this.getBannerHeight - this.filtersHeight;
            this.virtualScrollerWidth = "100%";
            this.mapHeight = window.innerHeight / 2 - 4 + "px";
            this.mapWidth = "100%;";
          } else {
            this.virtualScrollerHeight = window.innerHeight - this.$vuetify.application.top - this.$vuetify.application.footer - this.getBannerHeight - this.filtersHeight;
            this.virtualScrollerWidth = 200;
            this.mapHeight = this.virtualScrollerHeight + this.filtersHeight - 4 + "px";
            this.mapWidth = "100%;";
          }
          this.$nextTick(() => {
            resolve();
          });
        }, 20);
      }).catch();
    },
  },
  computed: {
    getItems() {
      var prop = this.devsSortTypes.find(st => st.name == this.devsSortType).prop;
      return this.dataitems.filter(i => !this.devsSearch || i.Name.contains(this.devsSearch) || i.sn.contains(this.devsSearch)).sort((a, b) => a[prop].localeCompare(b[prop], "bg", { sensitivity: "base" }));
    },
  },
};
</script>

<style>
</style>